import { Reveal, Overline } from "./Reveal";
import { useLang } from "@/i18n";
import { PORTS } from "@/data";
import { MapPin } from "lucide-react";

export const Destinations = () => {
  const { lang, t } = useLang();
  return (
    <section id="destinations" className="py-32 lg:py-40" data-testid="destinations-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t("destinations.overline")}</Overline>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t("destinations.title")}</h2>
            <p className="text-steel-400 max-w-md leading-relaxed">{t("destinations.sub")}</p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8">
          {PORTS.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.1} className={p.span}>
              <div className="group relative overflow-hidden border border-white/10 bg-surface h-full min-h-[320px] flex flex-col justify-end"
                data-testid={`port-card-${p.id}`}>
                <div className="absolute inset-0 overflow-hidden">
                  <img src={p.img} alt={p.name} loading="lazy" decoding="async"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                </div>
                <div className={`absolute inset-0 bg-gradient-to-t ${p.tint} via-abyss/60 to-abyss/20`} />
                <div className="absolute top-6 left-6 flex items-center gap-2 text-xs font-mono text-white/80 bg-black/40 backdrop-blur px-3 py-1.5 border border-white/10">
                  <MapPin size={12} className="text-ember" /> {p.country[lang]}
                </div>
                <div className="relative p-8">
                  <h3 className="font-display text-3xl lg:text-4xl font-bold uppercase tracking-tight">{p.name}</h3>
                  <p className="mt-3 text-sm text-steel-300 leading-relaxed max-w-lg">{p.desc[lang]}</p>
                  <p className="mt-5 text-xs uppercase tracking-widest text-steel-400">
                    {t("destinations.transit")} <span className="text-ember font-bold font-mono text-sm">{p.days}</span> {t("destinations.days")} — {t("destinations.from")}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
